module.exports = __webpack_public_path__ + "static/media/saatjaga.67564e50.svg";